import { BaseService } from '@/modules/Core/services/BaseService'
import type { IMediMedicamentosGenericos } from '@/modules/Farmacia/interfaces/tablas/IMediMedicamentosGenericos'
export class MedicamentoGenericoService extends BaseService<IMediMedicamentosGenericos> {
  constructor () {
    super({
      baseUrl: 'medicines/medicines/generic/'
    })
  }
}
